import { Outlet } from 'react-router';
import SidebarRestaurant from '../../components/SidebarRestaurant/SidebarRestaurant';
import RestaurantHeader from '../../components/RestaurantHeader/RestaurantHeader';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { fetchNotifications } from '../../redux/actions/notificationActions';
import { RootState, AppDispatch } from '../../redux/store';

const RestaurantPanel = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { token } = useSelector((state: RootState) => state.auth);
  const notifications = useSelector((state: RootState) => state.notifications.items);
  const loading = useSelector((state: RootState) => state.notifications.loading);

  useEffect(() => {
    if (token) {
      dispatch(fetchNotifications(token));
    }
  }, [dispatch, token]);

  return (
    <div className="flex w-full min-h-screen">
      <SidebarRestaurant />
      <div className="flex flex-col items-center flex-grow bg-white">
        {/* HEADER */}
        <div className="h-[64px] w-full flex items-center justify-end">
          <RestaurantHeader notifications={notifications} loading={loading} />
        </div>
        <div className="w-11/12">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default RestaurantPanel;
